module.exports = __webpack_public_path__ + "img/side.30b1d36a.png";